export class Room {
    id: number;
    roomTypeId: number;
    name: string;
    order: number;
    modifiedByUserName: string;
    modifiedDate: Date;
    createdDate: Date;
    inactiveDate: Date;
    roomTypeName: string;
}
